import {Errors} from "../../ConcorsandoWasm/Messages";

export default class BandiClient {
    defaultHeaders = {}
    basePath = ""

    /**
     * Singleton getter
     * @returns {BandiClient}
     */
    static get instance() {
        if (!this.thisInstance) {
            this.thisInstance = new BandiClient();
        }
        return this.thisInstance;
    }

    /**
     * Bandi in scadenza api
     * @returns {string}
     * @private
     */
    _buildBandiUrl() {
        return this.basePath;
    }

    /**
     * Adds app download banner after "Bandi in scadenza" text
     * @private
     */
    _addAppDownloadBanner() {
        // Trova il testo "Bandi in scadenza" nella pagina
        const textNodes = [];
        function findTextNodes(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                textNodes.push(node);
            } else {
                for (let i = 0; i < node.childNodes.length; i++) {
                    findTextNodes(node.childNodes[i]);
                }
            }
        }

        findTextNodes(document.body);

        // Cerca il nodo che contiene "Bandi in scadenza"
        let targetNode = null;
        for (let i = 0; i < textNodes.length; i++) {
            if (textNodes[i].textContent.includes("Bandi in scadenza")) {
                targetNode = textNodes[i].parentNode;
                break;
            }
        }

        if (targetNode) {
            // Crea il banner
            const banner = document.createElement('div');
            banner.style.backgroundColor = '#f8f9fa';
            banner.style.border = '1px solid #ddd';
            banner.style.borderRadius = '5px';
            banner.style.padding = '15px';
            banner.style.margin = '20px 0';
            banner.style.textAlign = 'center';

            // Aggiungi il testo
            const text = document.createElement('p');
            text.textContent = "Per accedere alle funzioni avanzate di questa sezione scarica l'app.";
            text.style.fontSize = '16px';
            text.style.marginBottom = '15px';
            banner.appendChild(text);

            // Contenitore per le immagini degli store
            const storeContainer = document.createElement('div');
            storeContainer.style.display = 'flex';
            storeContainer.style.justifyContent = 'center';
            storeContainer.style.gap = '20px';
            storeContainer.style.alignItems = 'center';

            // Definisci dimensioni fisse per entrambi i loghi
            const logoWidth = '135px';
            const logoHeight = '40px';

            // Contenitore per Google Play logo con dimensioni fisse
            const googlePlayContainer = document.createElement('div');
            googlePlayContainer.style.width = logoWidth;
            googlePlayContainer.style.height = logoHeight;
            googlePlayContainer.style.display = 'flex';
            googlePlayContainer.style.alignItems = 'center';
            googlePlayContainer.style.justifyContent = 'center';

            // Google Play badge
            const googlePlayLink = document.createElement('a');
            googlePlayLink.href = "https://play.google.com/store/search?q=concorsando&c=apps&hl=it";
            googlePlayLink.target = "_blank";
            googlePlayLink.id = 'google-play-link';
            googlePlayLink.style.display = 'block';
            googlePlayLink.style.width = '100%';
            googlePlayLink.style.height = '100%';

            const googlePlayImg = document.createElement('img');
            googlePlayImg.src = 'https://play.google.com/intl/en_us/badges/static/images/badges/it_badge_web_generic.png';
            googlePlayImg.alt = 'Disponibile su Google Play';
            googlePlayImg.style.width = '100%';
            googlePlayImg.style.height = '100%';
            googlePlayImg.style.objectFit = 'contain';

            googlePlayLink.appendChild(googlePlayImg);
            googlePlayContainer.appendChild(googlePlayLink);
            storeContainer.appendChild(googlePlayContainer);

            // Contenitore per App Store logo con dimensioni fisse
            const appStoreContainer = document.createElement('div');
            appStoreContainer.style.width = logoWidth;
            appStoreContainer.style.height = logoHeight;
            appStoreContainer.style.display = 'flex';
            appStoreContainer.style.alignItems = 'center';
            appStoreContainer.style.justifyContent = 'center';
            appStoreContainer.style.padding = '3px'

            // App Store badge
            const appStoreLink = document.createElement('a');
            appStoreLink.href = "https://apps.apple.com/it/app/concorsando-it/id543489205";
            appStoreLink.target = "_blank";
            appStoreLink.id = 'app-store-link';
            appStoreLink.style.display = 'block';
            appStoreLink.style.width = '100%';
            appStoreLink.style.height = '100%';

            const appStoreImg = document.createElement('img');
            appStoreImg.src = 'https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg';
            appStoreImg.alt = 'Scarica su App Store';
            appStoreImg.style.width = '100%';
            appStoreImg.style.height = '100%';
            appStoreImg.style.objectFit = 'contain';

            appStoreLink.appendChild(appStoreImg);
            appStoreContainer.appendChild(appStoreLink);
            storeContainer.appendChild(appStoreContainer);

            banner.appendChild(storeContainer);

            // Inserisci il banner dopo il nodo target
            targetNode.parentNode.insertBefore(banner, targetNode.nextSibling);
        }
    }

    async getBandi() {
        const req_url = this._buildBandiUrl();
        const res = await fetch(
            req_url,
            {
                mode: 'cors',
                method: 'GET',
                headers: {
                    ...this.defaultHeaders
                }
            }
        )
        if (!res.ok) {
            throw {code: Errors.REMOTE_REQUEST_FAILED}
        }
        const reader = res.body.getReader();
        // Step 3: read the data
        let receivedLength = 0; // received that many bytes at the moment
        let chunks = []; // array of received binary chunks (comprises the body)
        while(true) {
            const {done, value} = await reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            receivedLength += value.length;
        }
        // Step 4: concatenate chunks into single Uint8Array
        let chunksAll = new Uint8Array(receivedLength); // (4.1)
        let position = 0;
        for(let chunk of chunks) {
            chunksAll.set(chunk, position); // (4.2)
            position += chunk.length;
        }
        const newRespose = new Response(chunksAll)

        // Aggiungi il banner dopo aver caricato i dati
        setTimeout(() => this._addAppDownloadBanner(), 100);

        return newRespose.json();
    }
}
